import { object, string } from "valibot";

export const sentryErrorSchema = object({
  name: string(),
  message: string(),
  sentryTitle: string(),
  sentryMessage: string()
});
